import "@/instrument";
import * as Sentry from "@sentry/react";
import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"), {
  onUncaughtError: Sentry.reactErrorHandler(),
  onCaughtError: Sentry.reactErrorHandler(),
  onRecoverableError: Sentry.reactErrorHandler(),
});
root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary
      fallback={({ resetError }) => (
        <div className="min-h-screen flex flex-col items-center justify-center bg-slate-50 gap-4" data-testid="global-error-fallback">
          <h1 className="text-xl font-semibold text-slate-800">Something went wrong</h1>
          <p className="text-sm text-slate-500">Our team has been notified automatically.</p>
          <button
            data-testid="error-reset-btn"
            onClick={resetError}
            className="px-4 py-2 bg-[#1B2B5E] text-white rounded-lg text-sm font-medium"
          >
            Try again
          </button>
        </div>
      )}
    >
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
);
